module.exports = new __parcel__URL__("parrot.6fd92eec.svg").toString();